export const DeviceUserDepartmentEditSceneTranslation = {
  fi: {
    DeviceUserDepartmentEditScene: {
      title: 'Valitse osastot',
    },
  },
};
